module.exports = __webpack_public_path__ + "static/media/edit.65dfa0c8.svg";